import React, { useContext, useMemo, useState } from "react";
import Button from "../../../components/UI/button/GgButton";
import {
  dateFormat,
  formatCalcName,
  formatCurrency,
  formatDateTime,
} from "../../../utils";
import Modal from "../../../components/modal/Modal";
import { useModal } from "../../../customHooks/useModal";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ApplDetails from "./ApplDetails/ApplDetails";
import { Context } from "../../..";
import Spinner from "../../../components/UI/spinner/Spinner";

interface IApplItem {
  data?: any;
  user?: any;
  index?: any;
  key?: any;
  userId?: string;
  actionData?: any;
}

const ApplItem = ({ data, user, index, key, userId, actionData }: IApplItem) => {
  // console.log(JSON.parse((JSON.stringify(data)))) 
  const { users } = useContext(Context);
  const [loading, setLoading] = useState<boolean>(true);
  const results = data.result;
  const applicants = useMemo(() => {
    const applicants = data.inputData.applicants_info;
    const applArr = Array.from(
      { length: Object.keys(applicants).length / 4 },
      (_, index) => ({
        "first-name": applicants[`first-name-${index + 1}`],
        "last-name": applicants[`last-name-${index + 1}`],
        email: applicants[`email-${index + 1}`],
        phone: applicants[`phone-${index + 1}`],
      })
    );
    return applArr.map((item) => item["first-name"]).join(", ");
  }, [data]);

  const formatLoanAmount = (amount: number) => {
    return amount ? `${formatCurrency(amount)}` : "";
  };

  const modal = useModal();

  const handleDownload = async () => {
    const targetDiv = document.getElementById("calc-details");
    if (targetDiv) {
      const canvas = await html2canvas(targetDiv);
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;

      // Calculate the position for the text
      const textX = margin;
      const textY = margin + 10; // Add some vertical spacing before the image

      // Add additional text to the PDF
      pdf.setFontSize(12);
      pdf.text(formatCalcName(data.name.split(" ")[0]), textX, textY);
      pdf.text(user?.name || "", pageWidth - margin, textY, {
        align: "right",
      });
      pdf.setFontSize(10);
      pdf.text(user?.email || "", pageWidth - margin, textY + 5, {
        align: "right",
      });
      pdf.text(data.createdAt, pageWidth - margin, textY + 10, {
        align: "right",
      });

      // Calculate the dimensions of the image
      const imageWidth = pageWidth - 2 * margin;
      let imageHeight = (canvas.height * imageWidth) / canvas.width;
      let heightLeft = imageHeight;

      // Calculate the position for the image
      const imageX = margin;
      const imageY = textY + 10; // Add some vertical spacing after the text
      let position = imageY;

      // Add the captured image to the PDF
      pdf.addImage(imgData, "PNG", imageX, imageY, imageWidth, imageHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imageHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", imageX, position + 30, imageWidth, imageHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`${user?.name}.pdf`);
    }
  };

  const handleUserApplications = async (index: number) => {
    if (window.confirm("Are you sure you want to delete user application !")) {
      setLoading(false)  
      await users.deleteUserApplications(index)
      await users.loadOne(userId)
      setLoading(true) 
    }
  }

  return (
    <div className="card-item">
      <div className="card-info">
        <div className="card-title">House for rent</div>
        <div className="content">
          <span className="piece">
            Created: {formatDateTime(data.createdAt)} /{" "}
          </span>
          <span className="piece">
            Loan Amount Details: {formatLoanAmount(results?.LoanAmount)} /
          </span>
          <span className="piece">Applicants: {applicants}</span>
        </div>
      </div>
      <div className="controls">
        <Button
          label="View details"
          stylesType="border"
          onPress={modal.openModal}
        />
        {actionData?.delete ? (
          loading ? (
            <Button label="Delete" onPress={() => handleUserApplications(index)}/>
          ) : (
            <Spinner />
          )
        ) : ""}
      
      </div>
      <Modal
        show={modal.showModal}
        onClose={modal.setModalShow}
        title={"Application Details"}
        onSubmit={handleDownload}
        showSubmit={true}
        submitLabel="Download"
      >
        <ApplDetails result={data.result} inputData={data.inputData} />
      </Modal>
    </div>
  );
};

export default ApplItem;
